module.exports = __webpack_public_path__ + "img/symbol_7.89405911.png";